import actions from "./actions"
import { mutations } from "./mutations"
import getters from "./getters"
import { AppConfig } from "@/models/AppConfig"

export default {
	namespaced: true,
	state: (): AppConfig => {
		return {
			notifications: [],
			httpInProgress: false,
			modals: []
		}
	},
	mutations,
	actions,
	getters
}
